export default __webpack_public_path__ + "7793665.png";